import type { StoreTrajectoryConsultValues } from './store-trajectory-values'
import { useEffect, useState } from 'react'
import {
  type StoreTrajectory,
  useApiGetStoreTrajectory
} from '../../../../core/api/trajectory-photo/useApiGetStoreTrajectory'

const toStoreTrajectoryConsultValues = (data: StoreTrajectory) => {
  return {
    globalGmv: {
      omni: {
        gmv: { value: data?.omni.target_gmv, progression: data?.omni.target_gmv_progression },
        marginRate: { value: data?.omni.target_margin_rate, progression: data?.omni.target_margin_rate_progression },
        sellingPrice: {
          value: data?.omni.target_selling_price,
          progression: data?.omni.target_selling_price_progression
        },
        quantity: { value: data?.omni.target_quantity, progression: data?.omni.target_quantity_progression }
      },
      instore: {
        gmv: { value: data?.instore.target_gmv, progression: data?.instore.target_gmv_progression },
        marginRate: {
          value: data?.instore.target_margin_rate,
          progression: data?.instore.target_margin_rate_progression
        },
        sellingPrice: {
          value: data?.instore.target_selling_price,
          progression: data?.instore.target_selling_price_progression
        },
        quantity: { value: data?.instore.target_quantity, progression: data?.instore.target_quantity_progression }
      },
      outstore: {
        gmv: { value: data?.outstore.target_gmv, progression: data?.outstore.target_gmv_progression },
        marginRate: {
          value: data?.outstore.target_margin_rate,
          progression: data?.outstore.target_margin_rate_progression
        },
        sellingPrice: {
          value: data?.outstore.target_selling_price,
          progression: data?.outstore.target_selling_price_progression
        },
        quantity: { value: data?.outstore.target_quantity, progression: data?.outstore.target_quantity_progression }
      }
    },
    instoreGmvSegments: {
      channels: {
        physical: data?.instore.channels.target_physical_gmv,
        digital: data?.instore.channels.target_digital_gmv,
        decapro: data?.instore.channels.target_decapro_gmv
      },
      economies: {
        circular: data?.instore.economies.target_circular,
        nonCircular: data?.instore.economies.target_non_circular
      },
      circular: {
        repair: data?.instore.circular_economy.target_repair,
        secondLife: data?.instore.circular_economy.target_second_life,
        buyBack: data?.instore.circular_economy.target_buy_back,
        rental: data?.instore.circular_economy.target_rental
      }
    },
    validation: {
      validatorUid: data.last_update_uid,
      validationDate: data.last_update_date
    }
  }
}
const useStoreTrajectoryValidatedValues = (storeId: number, targetYear: number) => {
  const { isLoading, data } = useApiGetStoreTrajectory(storeId, targetYear, !!storeId && !!targetYear)

  const [storeTrajectoryConsultValues, setStoreTrajectoryConsultValues] = useState<StoreTrajectoryConsultValues>()

  useEffect(() => {
    if (data) {
      setStoreTrajectoryConsultValues(toStoreTrajectoryConsultValues(data))
    }
  }, [data])

  return {
    isLoading,
    storeTrajectoryConsultValues
  }
}

export default useStoreTrajectoryValidatedValues
